import clsx from "clsx";
import TextInput from "../TextInput/TextInput";
import { useCallback, useEffect, useMemo, useState } from "react";
import Button from "../Button/Button";
import { MdPersonSearch, MdSearchOff } from "react-icons/md";
import useInvites from "src/hooks/useInvites";
import Cards from "../Cards/Cards";
import NoTableData from "../NoTableData/NoTableData";
import { filter, sortBy } from "lodash";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

const SearchContactNetwork: React.FC = () => {
  const [searchText, setSearchText] = useState<string>("");
  const {
    searchPeople,
    receivedInvites,
    acceptedInvites,
    sentInvites,
    resetInvitesCache,
    isRefetchingInvites,
    isLoadingInvites,
  } = useInvites();
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [searchPerformed, setSearchPerformed] = useState<boolean>(false);
  const [isSearching, setIsSearching] = useState<boolean>(false);

  const excludeInSearchResults = useMemo(() => {
    return new Set(
      [...receivedInvites, ...acceptedInvites, ...sentInvites].flatMap(
        (inv: any) => [inv.from, inv.to],
      ),
    );
  }, [
    receivedInvites,
    acceptedInvites,
    sentInvites,
    isRefetchingInvites,
    isLoadingInvites,
  ]);

  const search = useCallback(
    async (search: string) => {
      setIsSearching(true);
      setSearchPerformed(false);
      const res = await searchPeople(search);

      if (res?.data?.success) {
        setSearchResults(res?.data?.data);
      }

      setIsSearching(false);
      setSearchPerformed(true);
    },
    [searchPeople],
  );

  const filteredSearchResults = useMemo(() => {
    return sortBy(
      filter(
        searchResults,
        (result: any) => !excludeInSearchResults.has(result._id), //&&
        // !!result?.settings?.privacy?.allowFindMe
      ),
      ["name"],
    );
  }, [searchResults, excludeInSearchResults]);

  useEffect(() => {
    if (searchText?.trim?.() === "") {
      setSearchPerformed(false);
      setSearchResults([]);
    }
  }, [searchText]);

  return (
    <div className={clsx(["flex", "flex-col", "gap-4", "mb-4"])}>
      <div className={clsx(["flex", "w-full", "flex-row", "gap-2"])}>
        <TextInput
          placeholder="Busca por nombre o correo..."
          onChange={(e: any) => {
            setSearchText(e?.target?.value);
          }}
          value={searchText}
          required
          disabled={isSearching}
          type="search"
          onEnter={() => {
            search(searchText);
          }}
        />
        <Button
          onClick={() => {
            search(searchText);
          }}
          icon={<MdPersonSearch size={ICON_SIZES.SM} />}
          kind={EButtonKind.NORMAL}
          isLoading={isSearching}
          disabled={isSearching /*|| searchText?.trim?.()?.length < 4*/}
        />
      </div>
      {isSearching ? (
        <NoTableData icon={<MdPersonSearch />} text="Buscando usuarios..." />
      ) : (
        <>
          {searchPerformed ? (
            <>
              {filteredSearchResults?.length > 0 ? (
                <Cards columns={3}>
                  {filteredSearchResults.map((user: any, index: number) => (
                    <Cards.SendContactInvite
                      user={user?._id}
                      animationIndex={index}
                      key={user._id}
                    />
                  ))}
                </Cards>
              ) : (
                <NoTableData
                  // icon={<MdSearchOff />}
                  text="Tu búsqueda no produjo resultados"
                />
              )}
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};
export default SearchContactNetwork;
